import React, { Component } from 'react';

import IconSprite from 'assets/sprite.svg';

class SvgIcon extends Component {
  render() {
    const {
      className,
      svgHref,
      style,
      useStyle,
      onClick
    } = this.props;
    return (
      <svg className={ className } style={ style }>
        <use
          href={ `${ IconSprite }#${ svgHref }` }
          xlinkHref={ `${ IconSprite }#${ svgHref }` }
          style={ useStyle }
          onClick={ onClick } />
      </svg>
    )
  }
}

export default SvgIcon;